<template>
    <div class="loader-container">
        <div class="spinner"></div>
        <p class="loader-text">Loading dealers...</p>
    </div>
</template>
<style>
.loader-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 16px;
    padding: 32px;
    min-height: 200px;
}

.spinner {
    width: 56px;
    height: 56px;
    border-radius: 50%;
    border: 9px solid;
    border-color: #dbdcef;
    border-right-color: #ff7f32;
    animation: spinner-d3wgkg 1s infinite linear;
}

.loader-text {
    margin: 0;
    color: #666;
    font-size: 16px;
    font-weight: 500;
    text-align: center;
}

@keyframes spinner-d3wgkg {
    to {
        transform: rotate(1turn);
    }
}
</style>